import { Register } from './router'

const ClientInformationModule = () => {
	const clientinformation = require(/* webpackChunkName: "clientinformation" */ '../modules/private/client/information')
	Register('clientInformation', clientinformation)
	return clientinformation
}

const ClientExtractOfPointsModule = () => {
	const clientextractofpoints = require(/* webpackChunkName: "clientextractofpoints" */ '../modules/private/client/extract-of-points')
	Register('clientExtractOfPoints', clientextractofpoints)
	return clientextractofpoints
}

const PointsPurchaseModule = () => {
	const pointspurchase = require(/* webpackChunkName: "pointspurchase" */ '../modules/private/client/points-purchase')
	Register('pointsPurchase', pointspurchase)
	return pointspurchase
}

const BuyWinModule = () => {
	const buyWin = require(/* webpackChunkName: "buywin" */ '../modules/private/client/buy-win')
	Register('buyWin', buyWin)
	return buyWin
}

const BuyWinPartnerModule = () => {
	const buyWinPartner = require(/* webpackChunkName: "buywinpartner" */ '../modules/private/client/buy-win-partner')
	Register('buyWinPartner', buyWinPartner)
	return buyWinPartner
}

const PointsPurchaseGiftModule = () => {
	const pointspurchasegift = require(/* webpackChunkName: "pointspurchasegift" */ '../modules/private/client/points-purchase')
	Register('pointsPurchaseGift', pointspurchasegift)
	return pointspurchasegift
}

const ProcessErrorModule = () => {
	const processerror = require(/* webpackChunkName: "processerror" */ '../modules/private/client/process-error')
	Register('processError', processerror)
	return processerror
}

const MyPurchasesModule = () => {
	const mypurchases = require(/* webpackChunkName: "mypurchases" */ '../modules/private/client/my-purchases')
	Register('myPurchases', mypurchases)
	return mypurchases
}

const PurchaseSuccessModule = () => {
	const purchasesuccess = require(/* webpackChunkName: "purchasesuccess" */ '../modules/private/client/purchase-success')
	Register('purchaseSuccess', purchasesuccess)
	return purchasesuccess
}

const ClubSuccessModule = () => {
	const clubsuccess = require(/* webpackChunkName: "clubsuccess" */ '../modules/private/client/club-success')
	Register('clubSuccess', clubsuccess)
	return clubsuccess
}

const WaitingTransferModule = () => {
	const waitingTransfer = require(/* webpackChunkName: "waitingTransfer" */ '../modules/private/client/waiting-transfer')
	Register('waitingTransfer', waitingTransfer)
	return waitingTransfer
}

const PlansModule = () => {
	const plans = require(/* webpackChunkName: "plans" */ '../modules/private/client/plans')
	Register('plans', plans)
	return plans
}

const MyPlanModule = () => {
	const myplan = require(/* webpackChunkName: "myplan" */ '../modules/private/client/my-plan')
	Register('myPlan', myplan)
	return myplan
}

const PayHistoryModule = () => {
	const payhistory = require(/* webpackChunkName: "payhistory" */ '../modules/private/client/pay-history')
	Register('payHistory', payhistory)
	return payhistory
}

const RegularizePaymentModule = () => {
	const regularizepayment = require(/* webpackChunkName: "regularizepayment" */ '../modules/private/client/regularize-payment')
	Register('rgularizePayment', regularizepayment)
	return regularizepayment
}

const CancelSubscriptionModule = () => {
	const cancelsubscription = require(/* webpackChunkName: "cancelsubscription" */ '../modules/private/client/cancel-subscription')
	Register('cancelSubscription', cancelsubscription)
	return cancelsubscription
}

const InviteYourFriendsModule = () => {
	const inviteYourfriends = require(/* webpackChunkName: "inviteYourfriends" */ '../modules/private/client/invite-your-friends')
	Register('inviteYourfriends', inviteYourfriends)
	return inviteYourfriends
}

const PointsTransferModule = () => {
	const pointstransfer = require(/* webpackChunkName: "pointsTransfer" */ '../modules/private/client/points-transfer')
	Register('pointsTransfer', pointstransfer)
	return pointstransfer
}

const StoreProductRedeemModule = () => {
	const storeProductRedeem = require(/* webpackChunkName: "storeProductRedeem" */ '../modules/private/client/store-product-redeem')
	Register('storeProductRedeem', storeProductRedeem)
	return storeProductRedeem
}

const StorePurchaseSuccessModule = () => {
	const storePurchaseSuccess = require(/* webpackChunkName: "storePurchaseSuccess" */ '../modules/private/client/store-purchase-success')

	Register('storePurchaseSuccess', storePurchaseSuccess)
	return storePurchaseSuccess
}

const PointsSolicitationModule = () => {
	const pointsSolicitation = require(/* webpackChunkName: "pointsSolicitation" */ '../modules/private/client/points-solicitation')
	Register('pointsSolicitation', pointsSolicitation)
	return pointsSolicitation
}

export {
	PointsTransferModule,
	ClientInformationModule,
	ClientExtractOfPointsModule,
	PointsPurchaseGiftModule,
	ProcessErrorModule,
	PointsPurchaseModule,
	BuyWinModule,
	BuyWinPartnerModule,
	PurchaseSuccessModule,
	MyPurchasesModule,
	ClubSuccessModule,
	WaitingTransferModule,
	PlansModule,
	MyPlanModule,
	PayHistoryModule,
	RegularizePaymentModule,
	CancelSubscriptionModule,
	InviteYourFriendsModule,
	StoreProductRedeemModule,
	StorePurchaseSuccessModule,
	PointsSolicitationModule,
}
